/*
  Rede de segurança para o acordeão exclusivo.

  Quem faz o trabalho é o atributo name do <details>, nativo: acordeões com o
  mesmo name se comportam como rádio, abrir um fecha o outro. Este arquivo só
  entra em cena em navegadores que ainda não implementaram isso — a checagem
  abaixo lê a propriedade no elemento, então onde o suporte existe nada aqui
  roda e não há risco de tratar o mesmo clique duas vezes.

  O evento toggle NÃO borbulha, por isso o listener fica em captura no
  document: assim um só listener cobre todos os acordeões da página, inclusive
  os que a Section Rendering API inserir depois.
*/
if (!('name' in document.createElement('details'))) {
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;

      const group = details.getAttribute('name');
      if (!group) return;

      document.querySelectorAll(`details[name="${CSS.escape(group)}"]`).forEach((other) => {
        if (other !== details) other.open = false;
      });
    },
    true
  );
}
